import { useSelector } from "react-redux";

export default function PoweredBy() {
  const environment = useSelector((state: any) => state?.environment);

  const getAgencyMeta = (type: 'websiteUrl' | 'poweredBy') => {
    const isWhitelabelAgency = ['WHITE_LABEL', 'SP_IMPLEMENTATION'].includes(environment?.agencyData?.type);
    const agencyPoweredBy = environment.agencyData?.isAgencyConfigurationEnabled?.poweredBy;

    switch (type) {
      case 'websiteUrl':
        return isWhitelabelAgency
          ? environment.agencyData.meta?.websiteUrl || ''
          : `https://botpenguin.com/?utm_source=referral&utm_medium=${window.location.host}&utm_campaign=chat_window`;
      case 'poweredBy':
        if (environment.whitelabel?.active) {
          return '';
        }

        return isWhitelabelAgency
          ? agencyPoweredBy
            ? environment?.agencyData?.meta?.poweredBy || ''
            : ''
          : <span> <span className="text-primaryText">Chat ⚡️ by Bot</span>Penguin </span>;
      default:
        return '';
    }
  }
  return (
    <>
      <div id='ele-24' className="">
        <a
          id='ele-25'
          href={getAgencyMeta('websiteUrl')}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: 'none',
            color: '#1661f5'
          }}>
          {getAgencyMeta('poweredBy')}
        </a>
      </div>
    </>
  )
}
